// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-header__collapsable {
  cursor: pointer;
  margin-bottom: 0;
}
.grid-header__collapsable .grid-header__collapsable-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.grid-header__collapsable[aria-expanded=true] .icon.icon-plus,
.grid-header__collapsable[aria-expanded=false] .icon.icon-minus {
  display: none;
}

.grid-header__collapsable .grid__heading,
.grid-header__collapsable .grid__subheading {
  margin-bottom: 0;
}

.grid__inner-collapsable {
  transition: max-height 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
}
.grid__inner-collapsable > .grid__inner-collapsible__content {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: var(--mobile-padding-size);
}

@media (min-width: 720px) {
  .grid__inner-collapsable > .grid__inner-collapsible__content {
    margin-top: var(--padding-size);
  }
}
.grid-separator__collapsable {
  position: absolute;
  left: 0;
  right: 0;
  margin-left: var(--space-outer);
  margin-right: var(--space-outer);
  bottom: 0;
  border-bottom: 1px solid var(--color-border);
  height: 1px;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/collapsable-grid/collapsable-grid.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACJ;;AAGA;;EAEE,aAAA;AAAF;;AAIE;;EAEE,gBAAA;AADJ;;AAKA;EACE,6DAAA;AAFF;AAIE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,sCAAA;AAFJ;;AAMA;EAEI;IACE,+BAAA;EAJJ;AACF;AAQA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,+BAAA;EACA,gCAAA;EACA,SAAA;EACA,4CAAA;EACA,WAAA;AANF","sourcesContent":[".grid-header__collapsable {\n  cursor: pointer;\n  margin-bottom: 0;\n\n  .grid-header__collapsable-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n}\n\n.grid-header__collapsable[aria-expanded=\"true\"] .icon.icon-plus,\n.grid-header__collapsable[aria-expanded=\"false\"] .icon.icon-minus {\n  display: none;\n}\n\n.grid-header__collapsable {\n  .grid__heading,\n  .grid__subheading {\n    margin-bottom: 0;\n  }\n}\n\n.grid__inner-collapsable {\n  transition: max-height 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;\n\n  > .grid__inner-collapsible__content {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: var(--mobile-padding-size);\n  }\n}\n\n@media (min-width: 720px) {\n  .grid__inner-collapsable {\n    > .grid__inner-collapsible__content {\n      margin-top: var(--padding-size);\n    }\n  }\n}\n\n.grid-separator__collapsable {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin-left: var(--space-outer);\n  margin-right: var(--space-outer);\n  bottom: 0;\n  border-bottom: 1px solid var(--color-border);\n  height: 1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
